<template>
  <div class="footer">
    <div class="con">
      <div class="left">
        <div class="language">
          <span @click="changLang('en-US')" :class="lang == 'en-US'?'active':''">English</span> |
          <span @click="changLang('zh-CN')" :class="lang == 'zh-CN'?'active':''">中文</span>
        </div>
        <div class="msg">
          <div class="icon i1" @click="gotoLink('social_twitter')"></div>
          <div class="icon i2" @click="gotoLink('social_medium')"></div>
          <div class="icon i3" @click="gotoLink('social_telegram')"></div>
        </div>
      </div>
      <div class="contact">
        <p class="f12 title">{{ $t('lang.contact') }}</p>
        <div class="emails">
          <div class="item">
            <p class="f12">{{$t('lang.emailGeneralTitle')}}</p>
            <p class="f12 addr">{{$t('lang.emailGeneral')}}</p>
          </div>
          <div class="item">
            <p class="f12">{{$t('lang.emailMediaTitle')}}</p>
            <p class="f12 addr">{{$t('lang.emailMedia')}}</p>
          </div>
        </div>
      </div>
      <div class="right">
        <p class="exchange f12">{{ $t('lang.exchange') }}</p>
        <p class="f12">{{ $t('lang.reserved') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { home } from "../common/link.js";
export default {
  name: "Footer",
  data() {
    return {
      lang: "en-US",
      link: home,
    };
  },
  methods: {
    changLang(lang) {
      this.lang = lang;
      this.$i18n.locale = lang;
    },
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(this.link[url], "_blank");
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.footer {
  width: 100%;
  background-color: $bgColor;

  .con {
    center();
    justify-content: space-between;
  }

  .left {
    flex: 5;

    .language {
      margin-bottom: 0.4rem;

      &:before {
        content: '';
        display: inline-block;
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.06rem;
        background: url('../assets/images/lang.png') center center no-repeat;
        background-size: 100% auto;
        vertical-align: middle;
        color: #8d929e;
      }

      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.18rem;
        margin: 0 0.05rem;
        color: #8d929e;
        cursor: pointer;

        &.active {
          color: $white;
        }
      }
    }

    .msg {
      margin-bottom: 0.2rem;
      center();

      .icon {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.3rem;
        cursor: pointer;

        &.i1 {
          background: url('../assets/images/i1.png') center center no-repeat;
          background-size: 100% auto;
        }

        &.i2 {
          background: url('../assets/images/i2.png') center center no-repeat;
          background-size: 100% auto;
        }

        &.i3 {
          background: url('../assets/images/i3.png') center center no-repeat;
          background-size: 100% auto;
        }
      }
    }
  }

  .contact {
    flex: 8;

    p {
      font-size: 0.14rem;
      line-height: 0.24rem;
      color: #888d99;

      &.title {
        margin-bottom: 0.3rem;
        font-size: 0.18rem;

        &:before {
          content: '';
          display: inline-block;
          width: 0.24rem;
          height: 0.19rem;
          margin-right: 0.06rem;
          margin-top: -0.04rem;
          background: url('../assets/images/email.png') center center no-repeat;
          background-size: 100% auto;
          vertical-align: middle;
          color: #8d929e;
        }
      }

      &.addr {
        color: $white;
      }
    }

    .emails {
      display: flex;

      .item {
        flex: 1;
        height: 0.5rem;

        p {
          margin-top: -0.1rem;
          line-height: 0.4rem;
        }

        &:first-child {
          flex: 4;
          border-right: 1px solid #b3b3b3;
        }

        &:last-child {
          flex: 5;
          padding-left: 0.18rem;
        }
      }
    }
  }

  .right {
    flex: 10;

    p {
      font-size: 0.14rem;
      line-height: 0.24rem;
      color: #888d99;

      &.exchange {
        margin-bottom: 0.16rem;
      }
    }
  }
}

@media screen and (max-width: 720px) {
  .footer {
    .con {
      flex-direction: column;
    }

    .left {
      width: 100%;
      center();
      justify-content: space-between;
      margin-bottom: 10px;

      .msg {
        .icon {
          margin-right: 0;
          margin-left: 1rem;
          width: 18px;
          height: 18px;
        }
      }

      .language {
        &:before {
          width: 0.42rem;
          height: 0.42rem;
          margin-right: 0.15rem;
        }

        span {
          font-size: 0.4rem;
        }
      }
    }

    .contact {
      width: 100%;
      margin: 15px auto;

      p {
        &.title {
          margin-bottom: 0.3rem;
          font-size: 0.18rem;

          &:before {
            content: '';
            display: inline-block;
            width: 0.6rem;
            height: 0.47rem;
            margin-right: 0.2rem;
            margin-top: -0.1rem;
            background: url('../assets/images/email.png') center center no-repeat;
            background-size: 100% auto;
            vertical-align: middle;
            color: #8d929e;
          }
        }
      }

      .emails {
        .item {
          height: 1.1rem;

          &:first-child {
            flex: 3;
          }

          &:last-child {
            flex: 2;
            padding-left: 1rem;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue